import { Document } from "./Document.dto";
import { DocumentSign } from "./DocumentSign.dto";
import { EconsentHistory } from "./Econsent.dto";
import { Folder, FolderType } from "./Folder.dto";
import { FolderFile } from "./FolderFile.dto";
import { Proposal } from "./Proposal.dto";
import { Sign } from "./Sign.dto";
import { Paginatable } from "../common/Paginatable.dto";
import { RefResourceType, RefServiceType } from "../ref/Ref.dto";
import { RefAuditAction, RefAuditCategory } from "../ref/RefAudit.dto";
import { UserEssential } from "../sso/User.dto";

export interface PaginateDocsAuditsRequest {
  organizationId: bigint;
  folderType: FolderType;
  folderId?: bigint;
  includeDeletedResource?: boolean;
}

export type PaginateDocsAuditsResponse = Paginatable<DocsAudit>;

export enum DocsAuditReservedResourceIdType {
  Folder = "FOLDER",
  FolderFile = "FOLDER_FILE",
  DocumentSigner = "DOCUMENT_SIGNER",
  Study = "STUDY",
  Signer = "SIGNER",
}

export enum DocsAuditReservedDataType {
  Entity = "ENTITY",
  Component = "COMPONENT",
  Data = "DATA",
}

export type DocsAuditReservedType = DocsAuditReservedResourceIdType | DocsAuditReservedDataType;

export enum DocsAuditReservedData {
  CancelReason = "CANCEL_REASON",
  Cidr = "CIDR",
  Code = "CODE",
  Content = "CONTENT",
  ContentStripped = "CONTENT_STRIPPED",
  CountryId = "COUNTRY_ID",
  Description = "DESCRIPTION",
  Email = "EMAIL",
  FolderId = "FOLDER_ID",
  IsLocked = "IS_LOCKED",
  IsDestroyed = "IS_DESTROYED",
  IsDownloadWithPasswordEnabled = "IS_DOWNLOAD_WITH_PASSWORD_ENABLED",
  IsDownloadWithWatermarkEnabled = "IS_DOWNLOAD_WITH_WATERMARK_ENABLED",
  IsDynamicWatermarkEnabled = "IS_DYNAMIC_WATERMARK_ENABLED",
  IsBlinded = "IS_BLINDED",
  IsEnabled = "IS_ENABLED",
  IsHidden = "IS_HIDDEN",
  IsIpWhitelistEnabled = "IS_IP_WHITELIST_ENABLED",
  IsLegacy = "IS_LEGACY",
  Label = "LABEL",
  No = "NO",
  Name = "NAME",
  ProtocolNo = "PROTOCOL_NO",
  ParentFolderId = "PARENT_FOLDER_ID",
  ParentSectionUuid = "PARENT_SECTION_UUID",
  PrevSectionUuid = "PREV_SECTION_UUID",
  SharingRole = "SHARING_ROLE",
  SigningReason = "SIGNING_REASON",
  StudyRole = "STUDY_ROLE",
  Title = "TITLE",
  TitleStripped = "TITLE_STRIPPED",
  Value = "VALUE",
  StudyZoneId = "STUDY_ZONE_ID",
  StudySectionId = "STUDY_SECTION_ID",
  StudyArtifactId = "STUDY_ARTIFACT_ID",
  UniqueId = "UNIQUE_ID",
  StudyMilestoneId = "STUDY_MILESTONE_ID",
  DatingConvention = "DATING_CONVENTION",
  IsMandatory = "IS_MANDATORY",
  Identifier = "IDENTIFIER",
  Group = "GROUP",
  TrialDescription = "TRIAL_DESCRIPTION",
  CountryDescription = "COUNTRY_DESCRIPTION",
  SiteDescription = "SITE_DESCRIPTION",
  UserId = "USER_ID",
  InviteStatus = "INVITE_STATUS",
  InviteExpiredAt = "INVITE_EXPIRED_AT",
  Status = "STATUS",
  IsBelongsAllSites = "IS_BELONGS_ALL_SITES",
  Index = "INDEX",
  Type = "TYPE",
  SystemVersion = "SYSTEM_VERSION",
  FileBucket = "FILE_BUCKET",
  FileKey = "FILE_KEY",
  FileExt = "FILE_EXT",
  Version = "VERSION",
  TmfLevel = "TMF_LEVEL",
  ConventionDate = "CONVENTION_DATE",
}

export type DocsAuditDataPayload = Partial<
  Pick<Folder, "name"> &
    Pick<FolderFile, "name"> &
    Pick<Proposal, "title"> &
    Pick<Document, "title"> &
    Pick<Sign, "title"> &
    Pick<EconsentHistory, "action" | "recordCount"> &
    Pick<DocumentSign, "title"> & { isDestroyed: boolean } & { resource: { name: string } }
  // TODO: Resource에 대해 세분화할 때 작업 필요. 2023/08/30
  // Pick<FolderSharing, "id"> &
  // Pick<FolderSharingSetting, "id"> &
  // Pick<FolderSharingIpWhitelist, "name"> &
  // Pick<FolderSharingLink, "id"> &
  // Pick<FolderVariable, "label"> &
  // Pick<ProposalTitle, "title"> &
  // Pick<ProposalVersion, "id"> &
  // Pick<ProposalContent, "id"> &
  // Pick<SignSignerAttr, "attr"> &
  // Pick<SignToken, "id"> &
  // Pick<DocumentSigner, "name"> &
  // Pick<DocumentSignerAttr, "attr"> &
>;

export interface DocsAudit {
  id: bigint;
  refId: bigint;
  organizationId: bigint | null;
  service: RefServiceType;
  type: RefResourceType;
  action: RefAuditAction;
  before: string;
  after: string;
  reasonKey: string;
  reason: string;
  actant: UserEssential;
  userAgent: string;
  category: RefAuditCategory;
  createdAt: Date;
  reserved1: string; // Folder Type
  reserved2: string; // Value 1 Type
  reserved3: string; // Value 1
  reserved4: string; // Value 2 Type
  reserved5: string; // Value 2
}
